module.exports = __webpack_public_path__ + "img/symbol-y2-center.02ee6eb9.png";